/* DHC B186 — measured, accessible carousel. One timer, no dependencies. */
(function () {
'use strict';
var instances = new WeakMap();
function init(root) {
  if (instances.has(root)) return;
  var track = root.querySelector('[data-dhc-viral-track]');
  if (!track) return;
  var cards = Array.prototype.slice.call(track.querySelectorAll('[data-dhc-viral-card]'));
  if (!cards.length) return;
  var prev=root.querySelector('[data-dhc-viral-prev]'), next=root.querySelector('[data-dhc-viral-next]');
  var pause=root.querySelector('[data-dhc-viral-pause]'), icon=root.querySelector('[data-dhc-viral-pause-icon]');
  var current=root.querySelector('[data-dhc-viral-current]'), total=root.querySelector('[data-dhc-viral-total]');
  var progress=root.querySelector('[data-dhc-viral-progress]'), fill=root.querySelector('[data-dhc-viral-progress-fill]');
  var media=window.matchMedia('(prefers-reduced-motion: reduce)');
  var autoplay=root.dataset.dhcViralAutoplay!=='false', loop=root.dataset.dhcViralLoop!=='false';
  var speed=Math.max(6,Math.min(30,Number(root.dataset.dhcViralSpeed)||12));
  var visible=true, hover=false, focus=false, touch=false, selected=false, userPaused=false, temporary=false;
  var destroyed=false, frame=0, last=0, timer=0, resizeTimer=0, observer=null, resizeObserver=null;
  var copies=[], start=0, cycle=0, width=0, loopReady=false, internal=false, manual=false, scrollTimer=0, position=0;
  var motionAllowed=false;
  root.dataset.dhcViralReady='true';
  track.style.setProperty('scroll-snap-type','none','important');
  track.style.setProperty('scroll-behavior','auto','important');
  // getBoundingClientRect measures relative to the actual scroll container.
  // offsetLeft is not safe here because product cards can have different offsetParents.
  function offset(el) { return el.getBoundingClientRect().left-track.getBoundingClientRect().left+track.scrollLeft; }
  function stop() { if(frame) cancelAnimationFrame(frame); frame=0; last=0; root.dataset.dhcViralMoving='false'; }
  function wrap(x) { return loopReady ? start+((x-start)%cycle+cycle)%cycle : Math.max(0,x); }
  function write(x) { internal=true; position=x; track.scrollLeft=x; internal=false; }
  function removeCopies() { copies.forEach(function(n){n.remove();}); copies=[];loopReady=false; }
  function cloneCard(card) {
    var node=card.cloneNode(true);
    node.removeAttribute('data-dhc-viral-card'); node.setAttribute('data-dhc-viral-clone','');
    node.setAttribute('aria-hidden','true'); node.setAttribute('inert',''); node.inert=true;
    node.querySelectorAll('[id]').forEach(function(el){el.removeAttribute('id');});
    node.querySelectorAll('[name]').forEach(function(el){el.removeAttribute('name');});
    node.querySelectorAll('a,button,input,select,textarea,[tabindex]').forEach(function(el){
      el.setAttribute('tabindex','-1');
      if(el.matches('button,input,select,textarea'))el.disabled=true;
    });
    node.querySelectorAll('video,audio').forEach(function(el){el.pause();el.removeAttribute('autoplay');});
    return node;
  }
  function build() {
    stop();clearTimeout(scrollTimer);
    var fraction=cycle?((track.scrollLeft-start)%cycle+cycle)%cycle/cycle:0;
    removeCopies();
    write(0);start=0;cycle=0;
    // Rebuild only from the real catalog cards, never from prior clones.
    if(loop && autoplay && !media.matches && cards.length>1) {
      var before=document.createDocumentFragment(), after=document.createDocumentFragment();
      cards.forEach(function(card){var a=cloneCard(card),b=cloneCard(card);before.appendChild(a);after.appendChild(b);copies.push(a,b);});
      track.insertBefore(before,cards[0]);track.appendChild(after);
      start=offset(cards[0]);
      // Same product in consecutive cycles gives exact cycle distance, including gap.
      var afterFirst=track.querySelectorAll('[data-dhc-viral-clone]')[cards.length];
      cycle=offset(afterFirst)-start;
      loopReady=cycle>1 && track.scrollWidth>track.clientWidth+1;
      if(loopReady)write(start+fraction*cycle);
    }
    width=track.clientWidth;update();sync();
  }
  function logicalX(){return loopReady?wrap(track.scrollLeft)-start:track.scrollLeft;}
  function update(){
    if(destroyed)return;
    var x=logicalX(),index=0;
    for(var i=0;i<cards.length;i++){
      if(offset(cards[i])-(loopReady?start:0)<=x+3)index=i;
    }
    if(current)current.textContent=index+1;if(total)total.textContent=cards.length;
    var max=Math.max(0,track.scrollWidth-track.clientWidth);
    if(prev)prev.disabled=cards.length<2||(!loopReady&&track.scrollLeft<2);
    if(next)next.disabled=cards.length<2||(!loopReady&&track.scrollLeft>=max-2);
    var pct=loopReady?x/cycle*100:(max?track.scrollLeft/max*100:100);
    pct=Math.max(0,Math.min(100,pct));
    if(fill)fill.style.width=pct+'%';
    if(progress)progress.setAttribute('aria-valuenow',String(Math.round(pct)));
  }
  function canRun(){return !destroyed&&autoplay&&!media.matches&&visible&&!hover&&!focus&&!touch&&!selected&&!userPaused&&!temporary&&!manual&&!document.hidden&&cards.length>1&&track.scrollWidth>track.clientWidth+1;}
  function tick(now){
    frame=0;if(!canRun()){last=0;return;}
    if(!last)last=now;
    var dt=Math.min(64,Math.max(0,now-last));last=now;
    var max=Math.max(0,track.scrollWidth-track.clientWidth);
    var x=position+speed*dt/1000;
    if(loopReady)x=wrap(x);else if(x>=max)x=0;
    write(x);update();frame=requestAnimationFrame(tick);
  }
  function sync(){if(canRun()){root.dataset.dhcViralMoving='true';if(!frame)frame=requestAnimationFrame(tick);}else stop();}
  function pauseFor(ms){temporary=true;stop();clearTimeout(timer);timer=setTimeout(function(){temporary=false;sync();},ms||3500);}
  function pauseUI(){
    if(!pause)return;
    pause.setAttribute('aria-pressed',String(userPaused));
    pause.setAttribute('aria-label',userPaused?'Resume carousel':'Pause carousel');
    if(icon)icon.textContent=userPaused?'▶':'Ⅱ';
  }
  function togglePause(){userPaused=!userPaused;if(!userPaused){clearTimeout(timer);temporary=false;}pauseUI();sync();}
  function move(dir){
    pauseFor(3500);manual=true;
    var x=track.scrollLeft, all=Array.prototype.slice.call(track.children);
    var candidates=dir>0?all:all.reverse();
    var target=candidates.find(function(c){return dir>0?offset(c)>x+4:offset(c)<x-4;});
    if(!target&&loopReady){write(wrap(x));x=track.scrollLeft;target=candidates.find(function(c){return dir>0?offset(c)>x+4:offset(c)<x-4;});}
    if(target){
      var dest=offset(target);
      position=dest;track.scrollTo({left:dest,behavior:media.matches?'auto':'smooth'});
      // The browser owns scrollLeft during smooth movement. Never race it with autoplay.
      clearTimeout(scrollTimer);scrollTimer=setTimeout(function(){manual=false;sync();update();},650);
    }else{manual=false;sync();}
  }
  function onScroll(){
    if(destroyed)return;
    if(!internal&&!manual&&!touch){
      if(Math.abs(track.scrollLeft-position)>1.1)position=track.scrollLeft;
      if(loopReady&&!temporary){
      var x=track.scrollLeft;
      if(x<start-cycle*.5||x>=start+cycle*1.5)write(wrap(x));
      }
    }
    update();
  }
  function onKey(e){if(e.target!==track)return;if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();move(e.key==='ArrowRight'?1:-1);}}
  function onResize(){clearTimeout(resizeTimer);resizeTimer=setTimeout(function(){if(!destroyed&&Math.abs(track.clientWidth-width)>1)build();},180);}
  function onMedia(){build();}
  function onVisibility(){sync();}
  function onHoverIn(){hover=true;sync();}function onHoverOut(){hover=false;sync();}
  function onFocusIn(){focus=true;sync();}function onFocusOut(e){if(!root.contains(e.relatedTarget)){focus=false;sync();}}
  function onTouchStart(){touch=true;stop();}function onTouchEnd(){touch=false;pauseFor(3500);sync();}
  function onPointerDown(e){if(e.pointerType==='mouse'&&!e.target.closest('[data-dhc-viral-pause]'))pauseFor(3500);}
  function onSelect(e){if(e.detail&&e.detail.sectionId===root.id.replace('dhc-viral-','')){selected=true;sync();}}
  function onDeselect(){selected=false;sync();}
  function destroy(){
    destroyed=true;stop();clearTimeout(timer);clearTimeout(resizeTimer);clearTimeout(scrollTimer);removeCopies();
    if(observer)observer.disconnect();if(resizeObserver)resizeObserver.disconnect();
    document.removeEventListener('visibilitychange',onVisibility);
    document.removeEventListener('shopify:section:select',onSelect);document.removeEventListener('shopify:section:deselect',onDeselect);
    if(media.removeEventListener)media.removeEventListener('change',onMedia);else if(media.removeListener)media.removeListener(onMedia);
    window.removeEventListener('resize',onResize);
    track.removeEventListener('scroll',onScroll);track.removeEventListener('keydown',onKey);
    root.removeEventListener('mouseenter',onHoverIn);root.removeEventListener('mouseleave',onHoverOut);
    root.removeEventListener('focusin',onFocusIn);root.removeEventListener('focusout',onFocusOut);
    root.removeEventListener('touchstart',onTouchStart);root.removeEventListener('touchend',onTouchEnd);root.removeEventListener('touchcancel',onTouchEnd);root.removeEventListener('pointerdown',onPointerDown);
    root.removeAttribute('data-dhc-viral-ready');root.removeAttribute('data-dhc-viral-moving');instances.delete(root);
  }
  instances.set(root,{destroy:destroy});
  if(prev)prev.addEventListener('click',function(){move(-1);});
  if(next)next.addEventListener('click',function(){move(1);});
  if(pause)pause.addEventListener('click',togglePause);
  track.addEventListener('scroll',onScroll,{passive:true});track.addEventListener('keydown',onKey);
  root.addEventListener('mouseenter',onHoverIn);root.addEventListener('mouseleave',onHoverOut);
  root.addEventListener('focusin',onFocusIn);root.addEventListener('focusout',onFocusOut);
  root.addEventListener('touchstart',onTouchStart,{passive:true});root.addEventListener('touchend',onTouchEnd,{passive:true});root.addEventListener('touchcancel',onTouchEnd,{passive:true});root.addEventListener('pointerdown',onPointerDown,{passive:true});
  document.addEventListener('visibilitychange',onVisibility);document.addEventListener('shopify:section:select',onSelect);document.addEventListener('shopify:section:deselect',onDeselect);
  if(media.addEventListener)media.addEventListener('change',onMedia);else if(media.addListener)media.addListener(onMedia);
  if('ResizeObserver'in window){resizeObserver=new ResizeObserver(onResize);resizeObserver.observe(track);}else window.addEventListener('resize',onResize);
  if('IntersectionObserver'in window){visible=false;observer=new IntersectionObserver(function(entries){visible=entries[0].isIntersecting;sync();},{threshold:.05});observer.observe(root);}
  build();pauseUI();
}
function all(scope){(scope||document).querySelectorAll('[data-dhc-viral-carousel]').forEach(init);}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){all();});else all();
document.addEventListener('shopify:section:load',function(e){all(e.target);});
document.addEventListener('shopify:section:unload',function(e){e.target.querySelectorAll('[data-dhc-viral-carousel]').forEach(function(root){var instance=instances.get(root);if(instance)instance.destroy();});});
})();
